export var SearchTypes = ['normal', 'new-price', 'new-listings', 'strict-new-listings'];
export var DefaultSearchType = 'normal';
export var parseSearchType = function parseSearchType(value) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DefaultSearchType;
  if (!value) {
    return defaultValue;
  }
  if (SearchTypes.includes(value)) {
    return value;
  }
  return defaultValue;
};